import { render, staticRenderFns } from "./CardWithOGP.vue?vue&type=template&id=362be768&"
import script from "./CardWithOGP.vue?vue&type=script&lang=js&"
export * from "./CardWithOGP.vue?vue&type=script&lang=js&"
import style0 from "./CardWithOGP.vue?vue&type=style&index=0&id=362be768&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports